import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { Container, Navbar, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from "../../../layout/default";
import './AdminPanel.css'; // Import a custom CSS file for additional styling

const AdminPanel = () => {
    return (
        <Layout title="Admin-panel">
            <Navbar bg="dark" variant="dark" expand="lg" className="shadow">
                <Container>
                    <Navbar.Brand
                        as={Link}
                        to="/shop/admin/admin-panel"
                        className="fw-bold text-uppercase"
                    >
                        Admin Panel
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                        <Nav.Link
                                as={Link}
                                to="/shop/admin/admin-dashboard"
                                className="nav-item-custom"
                            >
                                Admin Dashboard
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/admin-comission"
                                className="nav-item-custom"
                            >
                                Admin Comission
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/unit-list"
                                className="nav-item-custom"
                            >
                                Unit
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/category-list"
                                className="nav-item-custom"
                            >
                                Category
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/product-list"
                                className="nav-item-custom"
                            >
                                Product
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/product-variant-list"
                                className="nav-item-custom"
                            >
                                Product Variant
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/admin-orders"
                                className="nav-item-custom"
                            >
                                Admin Orders List
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/Updated-Customer-Password"
                                className="nav-item-custom"
                            >
                                Update Customer Password
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/admin-skos-list"
                                className="nav-item-custom"
                            >
                                Admin SKU List
                            </Nav.Link>
                            <Nav.Link
                                as={Link}
                                to="/shop/admin/admin-customer"
                                className="nav-item-custom"
                            >
                                Customer List
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </Layout>
    );
};

export default AdminPanel;
